import {connect} from "react-redux";
import FunctionSidebar from "./FunctionSidebar";
import {
    contactSelector,
    descriptionSelector,
    disabledRoomSelector,
    getContractStageSelector,
    getPrioritySelector, getHasActiveContractBtnSelector,
    hasActiveRoomSelector,
    hasDisabledRoomSelector,
    locationSelector,
    photosSelector,
    progressItemsHasProblemSelector,
    progressItemsSelector,
    progressSelector,
    rulesSelector,
    servicesSelector, getPaymentTypeSelector, getVerifiedUserStatusSelector
} from "./selectors";
import {getUserRoleSelector} from "../../../globalState/app/selectros";
import {clearSearch, getObjectsList} from "../../Objects/actions";


let mapStateToProps = (state) => {
    return {
        objectId: state.object.id,
        getPaymentType: getPaymentTypeSelector(state),
        description: descriptionSelector(state),
        photos: photosSelector(state),
        location: locationSelector(state),
        contact: contactSelector(state),
        services: servicesSelector(state),
        rules: rulesSelector(state),
        hasActiveRoom: hasActiveRoomSelector(state),
        disabledRoom: disabledRoomSelector(state),
        verifiedUserStatus: getVerifiedUserStatusSelector(state),
        hasDisabledRoom: hasDisabledRoomSelector(state),
        progress: progressSelector(state),
        progressItems: progressItemsSelector(state),
        progressItemsHasProblem: progressItemsHasProblemSelector(state),
        priority: getPrioritySelector(state),
        contractStage: getContractStageSelector(state),
        hasActiveContractBtn: getHasActiveContractBtnSelector(state),
        userRole: getUserRoleSelector(state),

    }
};


export default connect(mapStateToProps, {getObjectsList, clearSearch})(FunctionSidebar);




